import { ServiceRequest } from "../utils/service-request"
import {
    MOTOR_CADASTRO_PATH,
    MOTOR_CADASTRO_TEMPORARIO_PATH
} from "../utils/api-routes"

class MotorEventosOrdinariosService {
    constructor() {
        this.request = new ServiceRequest()
    }

    async getTemporarioEventosOrdinarios(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/eventos-ordinarios`
        return this.request.get(path)
    }

    async getEventosOrdinarios(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/eventos-ordinarios`
        return this.request.get(path)
    }

    async createCadastroTemporarioEventosOrdinarios(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/eventos-ordinarios`
        return this.request.post(path, payload)
    }

    async createCadastroEventosOrdinarios(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/eventos-ordinarios`
        return this.request.post(path, payload)
    }

    async updateCadastroEventosOrdinarios(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/eventos-ordinarios`
        return this.request.put(path, payload)
    }

    async deleteCadastroTemporarioEventosOrdinarios(id){
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/eventos-ordinarios`
        return this.request.delete(path)
    }

    async deleteCadastroEventosOrdinarios(id){
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/eventos-ordinarios`
        return this.request.delete(path)
    }


}

export default MotorEventosOrdinariosService